(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    const setHeaderHeight = () => {
      const h = this.header ? this.header.offsetHeight : 0;
      document.documentElement.style.setProperty('--header-height', `${h}px`);
    };
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
  }
}
customElements.define('sticky-header', StickyHeader);

/* Toggle voor uitklap-zoekbalk (SEARCH) */
(function(){
  const btn = document.getElementById('search-toggle');
  const panel = document.getElementById('site-search');
  const input = document.getElementById('Search-UnderHeader');
  if (!btn || !panel) return;

  function openSearch(){
    panel.hidden = false;
    panel.classList.add('is-open');
    btn.setAttribute('aria-expanded','true');
    setTimeout(()=>{ try{ input && input.focus(); }catch(e){} }, 0);
  }
  function closeSearch(){
    panel.classList.remove('is-open');
    panel.hidden = true;
    btn.setAttribute('aria-expanded','false');
  }
  function toggleSearch(){ panel.hidden ? openSearch() : closeSearch(); }

  btn.addEventListener('click',(e)=>{ e.preventDefault(); toggleSearch(); });
  document.addEventListener('keydown',(e)=>{ if(e.key==='Escape' && !panel.hidden) closeSearch(); });
  document.addEventListener('click',(e)=>{
    if(panel.hidden) return;
    const within = panel.contains(e.target) || btn.contains(e.target);
    if(!within) closeSearch();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
